var _g, _path, _circle, _ellipse, _ellipse2, _circle2, _circle3, _ellipse3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvilMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1203,
    height: 1190,
    viewBox: "0 0 1203 1190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1254_4055)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 601.227,
    cy: 594.726,
    rx: 491,
    ry: 484.5,
    fill: "#FFFFC6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M382.388 161.226C290.981 249.217 234.227 372.098 234.227 508.059C234.227 775.641 454.055 992.559 725.227 992.559C803.859 992.559 878.174 974.318 944.064 941.892C855.576 1027.07 734.613 1079.56 601.227 1079.56C330.055 1079.56 110.227 862.641 110.227 595.059C110.227 405.069 221.05 240.623 382.388 161.226Z",
    fill: "#DCE5B8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 472.227,
    cy: 439.559,
    r: 67,
    fill: "#D8E5B8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 810.727,
    cy: 553.559,
    rx: 94.5,
    ry: 95,
    fill: "#D8E5B8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 764.227,
    cy: 335.059,
    rx: 49,
    ry: 48.5,
    fill: "#D8E5B8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 520.727,
    cy: 744.059,
    r: 31.5,
    fill: "#D8E5B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 812.727,
    cy: 780.059,
    r: 31.5,
    fill: "#D8E5B8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 988.227,
    cy: 624.059,
    rx: 21,
    ry: 21.5,
    fill: "#D8E5B8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 544.727,
    cy: 223.059,
    r: 27.5,
    fill: "#D8E5B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1254_4055",
    x: 0.000488281,
    y: 0,
    width: 1202.45,
    height: 1189.45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 55.113
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.802115 0 0 0 0 0.406344 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1254_4055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1254_4055",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvilMoon);
export default __webpack_public_path__ + "static/media/evilMoon.ef6161eef48301e7b070d04f3c55619c.svg";
export { ForwardRef as ReactComponent };